export const SUBMIT_MERCHANT_APPLICATION = gql`
    mutation SubmitMerchantApplication($applicationId: Int!) {
        submitMerchantApplication(applicationId: $applicationId)
    }
`;
